/* BBT custom JS */
jQuery(document).ready(function ($) {

    //---------------------------------------
    // bbt-toggle (mobile dropdowns)
    //---------------------------------------

    // bbt toggle click
    var bbt_toggle_object = new bbt_toggle();
    bbt_toggle_object.init();

    function bbt_toggle() {
        this.active_toggles = [];
        this.body_overlay_class = 'body-overlay';
        this.sourceElement = null;
        this.targetElement = null;
        this.targetElementClass = null;
        var self = this;

        this.init = function () {
            this.on_toggle_click();
            this.on_overlay_click();
            this.on_window_resize();
        };

        this.on_window_resize = function () {
            $(window).resize(function () {
                if ($(window).width() > 639) {
                    self.close_active_toggles();
                }
            });
        };

        this.on_toggle_click = function () {
            $('[data-bbt-toggle]').on('click', function (e) {
                e.preventDefault();
                self.sourceElement = $(this);
                self.targetElement = $(self.sourceElement.data('bbt-toggle'));
                self.targetElementClass = self.targetElement.data('bbt-toggler');

                // toggle target class
                if (!self.targetElement.hasClass(self.targetElementClass)) {
                    self.close_active_toggles();
                    self.open_toggle();
                    self.add_overlay();
                } else {
                    self.close_active_toggles();
                }
            });
        };

        this.on_overlay_click = function () {
            $(document).on('click', '.' + self.body_overlay_class, function () {
                self.close_active_toggles();
            });
        };

        this.remove_overlay = function () {
            $('.' + self.body_overlay_class).remove();
        };

        this.add_overlay = function () {
            $('<div class="' + self.body_overlay_class + '"></div>').appendTo('body');
        };

        this.close_active_toggles = function () {

            temp_sourceElement = self.sourceElement;
            temp_targetElement = self.targetElement;
            temp_targetElementClass = self.targetElementClass;

            if (typeof self.active_toggles != 'undefined' && self.active_toggles.length > 0) {
                $.each(self.active_toggles, function ($key, $source) {

                    self.sourceElement = $source;
                    self.targetElement = $(self.sourceElement.data('bbt-toggle'));
                    self.targetElementClass = self.targetElement.data('bbt-toggler');

                    self.close_active_toggle();
                });
            }

            // remove overlay
            self.remove_overlay();

            self.sourceElement = temp_sourceElement;
            self.targetElement = temp_targetElement;
            self.targetElementClass = temp_targetElementClass;

            self.active_toggles = [];
        };

        this.close_active_toggle = function () {
            self.sourceElement.removeClass('bbt-toggle-expanded');
            self.targetElement.removeClass(self.targetElementClass);
        };

        this.open_toggle = function () {
            self.active_toggles.push(self.sourceElement);
            // add class to source and target element
            self.targetElement.addClass(self.targetElementClass);
            self.sourceElement.addClass('bbt-toggle-expanded');

        };
    }


    //---------------------------------------
    // mega menu
    //---------------------------------------
    $(".js-megamenu").accessibleMegaMenu({
        /* prefix for generated unique id attributes, which are required
           to indicate aria-owns, aria-controls and aria-labelledby */
        uuidPrefix: "accessible-megamenu",

        /* css class used to define the megamenu styling */
        menuClass: "main-nav-desktop",

        /* css class for a top-level navigation item in the megamenu */
        topNavItemClass: "main-nav-desktop__item",

        /* css class for a megamenu panel */
        panelClass: "sub-nav",

        /* css class for a group of items within a megamenu panel */
        panelGroupClass: "sub-nav-group",

        /* css class for the hover state */
        hoverClass: "hover",

        /* css class for the focus state */
        focusClass: "focus",

        /* css class for the open state */
        openClass: "open"
    });


    //---------------------------------------
    // custom <select> styles
    //---------------------------------------
    $("select").selectBoxIt();


    //---------------------------------------
    // custom style range slider https://refreshless.com/nouislider/
    //---------------------------------------
    var priceRange = document.getElementById('js-price-range');
    if (priceRange != null) {
        var inputMin = document.getElementById('js-price-range-value-lower');
        var inputMax = document.getElementById('js-price-range-value-upper');
        var inputMinValue = parseFloat(inputMin.value, 10);
        var inputMaxValue = parseFloat(inputMax.value, 10);
        var inputMinPossibleValue = parseFloat(inputMin.dataset.min, 10);
        var inputMaxPossibleValue = parseFloat(inputMax.dataset.max, 10);
        var inputs = [inputMin, inputMax];

        if (inputMinValue == '') {
            inputMinValue = inputMinPossibleValue;
        }

        if (inputMaxValue == '') {
            inputMaxValue = inputMaxPossibleValue;
        }

        noUiSlider.create(priceRange, {
            start: [inputMinValue, inputMaxValue],
            connect: true,
            range: {
                'min': inputMinPossibleValue,
                'max': inputMaxPossibleValue
            },
            step: 0.01
        });

        // update input values on slider scroll
        priceRange.noUiSlider.on('update', function (values, handle) {
            inputs[handle].value = values[handle];
        });

        // submit form
        priceRange.noUiSlider.on('change', function (values, handle) {
            // $('#js-price-range').closest("form").submit();
        });

        // link input value change to range slider
        function setSliderHandle(i, value) {
            var r = [null, null];
            r[i] = value;
            priceRange.noUiSlider.set(r);
        }

        // Listen to keydown events on the input field.
        inputs.forEach(function (input, handle) {

            input.addEventListener('change', function () {
                setSliderHandle(handle, this.value);
            });

            input.addEventListener('keydown', function (e) {

                var values = priceRange.noUiSlider.get();
                var value = Number(values[handle]);

                // [[handle0_down, handle0_up], [handle1_down, handle1_up]]
                var steps = priceRange.noUiSlider.steps();

                // [down, up]
                var step = steps[handle];

                var position;

                // 13 is enter,
                // 38 is key up,
                // 40 is key down.
                switch (e.which) {

                    case 13:
                        setSliderHandle(handle, this.value);
                        break;

                    case 38:

                        // Get step to go increase slider value (up)
                        position = step[1];

                        // false = no step is set
                        if (position === false) {
                            position = 1;
                        }

                        // null = edge of slider
                        if (position !== null) {
                            setSliderHandle(handle, value + position);
                        }

                        break;

                    case 40:

                        position = step[0];

                        if (position === false) {
                            position = 1;
                        }

                        if (position !== null) {
                            setSliderHandle(handle, value - position);
                        }

                        break;
                }
            });
        });
    }


    //---------------------------------------
    // ajax to remove cart products
    //---------------------------------------
    var bbt_menu_cart_object = new bbt_menu_cart();
    bbt_menu_cart_object.init();

    function bbt_menu_cart() {
        this.basket_button_class = 'js-show-basket';
        this.active_basket_class = 'header-desktop-basket--active';
        this.basket_button = $('.' + this.basket_button_class);
        var self = this;


        this.init = function () {
            self.on_item_remove_click();
            self.on_basket_click();
            self.on_window_resize();
            self.on_body_click();

            setTimeout(function () {
                $('body').addClass('wc-fragments-refreshed');
            }, 2000);

            $(document.body).on('wc_fragment_refresh wc_fragments_refreshed wc_fragments_loaded', function () {
                $('body').addClass('wc-fragments-refreshed');

                self.basket_button = $('.' + self.basket_button_class);

                self.on_basket_click();
                self.on_body_click();
            });
        };

        this.toggle_desktop_basket = function () {
            self.basket_button.toggleClass(self.active_basket_class);
        };

        this.open_desktop_basket = function () {
            self.basket_button.addClass(self.active_basket_class);
        };

        this.close_desktop_basket = function () {
            self.basket_button.removeClass(self.active_basket_class);
        };

        this.add_basket_overlay = function () {
            $('<div class="basket-overlay"></div>').appendTo('#mobile-basket');
            $('<div class="basket-overlay"></div>').appendTo('.header-desktop-basket__dropdown');
        };

        this.remove_basket_overlay = function () {
            $('.basket-overlay').remove();
        };

        this.update_desktop_basket_badge = function ($count) {
            $('.header-desktop-basket__badge').html($count);
        };

        this.clear_basket_content = function ($return) {
            $('#mobile-basket').html('<p>' + aw_vars.empty_cart_text + '</p>'); // Mobile
            $('.header-desktop-basket__dropdown').html('<p>' + aw_vars.empty_cart_text + '</p>'); // Desktop

        };

        this.update_cart_total = function ($total_html) {
            $('.cart-list__price').html($total_html); // Mobile
            $('.header-desktop-basket__price').html($total_html); // Desktop
        };

        this.remove_item_from_cart = function (product_id) {
            $('#cart_item_' + product_id).remove(); // Mobile
            $('#cart_item_desktop_' + product_id).remove(); // Desktop
        };

        this.on_item_remove_click = function () {
            $('.cart-list__remove-item').on('click', function (e) {
                e.preventDefault();
                var product_id = $(this).data('product');
                $.ajax({
                    type: 'POST',
                    dataType: 'json',
                    url: aw_vars.ajax_url,
                    data: {
                        'action': 'aw_remove_cart_item',
                        'product_id': product_id,
                    },
                    beforeSend: function (xhr) {
                        self.add_basket_overlay();
                    }
                })
                    .done(function ($return) {
                        if ($return.status === 'ok') {
                            self.remove_item_from_cart(product_id);
                            self.update_cart_total($return.cart_total);
                            if ($return.cart_item_count < 1) {
                                self.clear_basket_content($return);
                                self.close_desktop_basket();
                                bbt_toggle_object.close_active_toggles();
                            }
                            self.update_desktop_basket_badge($return.cart_item_count);
                        }
                    })
                    .always(function () {
                        self.remove_basket_overlay();
                    });
            });
        };

        this.on_window_resize = function () {
            $(window).resize(function () {
                if ($(window).width() < 640) {
                    self.close_desktop_basket();
                }
            });
        };

        this.on_basket_click = function () {
            // show desktop basket
            self.basket_button.on("click", function (e) {
                e.preventDefault();
                self.toggle_desktop_basket();
            });
        };

        this.on_body_click = function () {
            $('body').on('click', function (e) {
                if (e.target.className === "header-desktop-basket__wrapper")
                    return;
                if ($(e.target).closest('.header-desktop-basket__wrapper').length)
                    return;
                self.close_desktop_basket();
            });
        };

    };

    //---------------------------------------
    // submit form when change "display items" selectbox
    //---------------------------------------
    $(".woocommerce-ordering").on("change", "select.displayitems", function () {
        $(this).closest("form").submit();
    });

    //---------------------------------------
    // submit form when change sidebar filters
    //---------------------------------------
    $(".sidebar-mobile-switcher__container").on("change", "input", function () {
        // $(this).closest("form").submit();
    });

    //---------------------------------------
    // matchHeight plugin
    //---------------------------------------
    $('.js-matchHeight').matchHeight();


    //---------------------------------------
    // category switch button
    //---------------------------------------
    $('.js-sidebar-mobile-switcher').on('click', function (e) {
        e.preventDefault();
        $(this).toggleClass('sidebar-mobile-switcher__button--active');
    });


    //---------------------------------------
    // homepage slider
    //---------------------------------------
    $('.js-homepage-slider').slick({
        arrows: true,
        dots: true,
        // autoplay: true,
        // autoplaySpeed: 5000,
        responsive: [
            {
                breakpoint: 640,
                settings: {
                    arrows: false
                }
            }
        ]
    });

    $('.js-homepage-popular-products__nav').on('init', function (slick) {
        var category = $('.homepage-popular-products__nav-item.slick-current').data('category');

        $('.js-similar-products-slider[data-category="' + category + '"]').show().slick({
            arrows: false,
            dots: true,
            slidesToShow: 1,
            slidesToScroll: 1,
        });
    });

    $('.js-homepage-popular-products__nav').slick({
        arrows: true,
        dots: false,
        // slidesToShow: 1,
        slidesToScroll: 1,
        // variableWidth: true,
        focusOnSelect: true,
        //centerMode: true
        //asNavFor: '.js-similar-products-slider'
        // autoplay: true,
        // autoplaySpeed: 5000,
        responsive: [
            {
                breakpoint: 640,
                settings: {
                    slidesToShow: 1,

                    // arrows: false
                }
            },
            {
                breakpoint: 10024,
                settings: {
                    slidesToShow: 4,
                    variableWidth: true
                    // arrows: false
                }
            }
        ]
    });

    $('.homepage-popular-products__nav-item').on('click', function (e) {
        try {
            $('.js-similar-products-slider.slick-initialized').slick('unslick');
            $('.js-similar-products-slider').hide();
        } catch (e) {
        }

        var category = $(this).data('category');
        $('.js-similar-products-slider[data-category="' + category + '"]').show().slick({
            arrows: false,
            dots: true,
            slidesToShow: 1,
            slidesToScroll: 1,
        });
    });

    $('.js-homepage-popular-products__nav').on('afterChange', function (slick, currentSlide) {
        try {
            $('.js-similar-products-slider.slick-initialized').slick('unslick');
            $('.js-similar-products-slider').hide();
        } catch (e) {
        }

        var category = $('.homepage-popular-products__nav-item.slick-current').data('category')
        $('.js-similar-products-slider[data-category="' + category + '"]').show().slick({
            arrows: false,
            dots: true,
            slidesToShow: 1,
            slidesToScroll: 1,
        });
    })


    //---------------------------------------
    // single product - similar products slider
    //---------------------------------------

    $('.single-product .js-similar-products-slider').each(function () {
        $(this).slick({
            arrows: false,
            dots: true,
            slidesToShow: 1,
            slidesToScroll: 1,
        });
    });


    // $('.js-homepage-popular-products-slider').slick({
    //   arrows: false,
    //   dots: false,
    //   slidesToShow: 1,
    //   slidesToScroll: 1,
    //   asNavFor: '.js-homepage-popular-products__nav';
    // });

    //---------------------------------------
    // single product slider
    //---------------------------------------
    $('.js-single-product-slider').slick({
        arrows: false,
        dots: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        asNavFor: '.js-single-product-slider-nav'
    });

    $('.js-single-product-slider-nav').slick({
        arrows: true,
        dots: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        asNavFor: '.js-single-product-slider',
        focusOnSelect: true,
        responsive: [
            {
                breakpoint: 1138,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 950,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 760,
                settings: {
                    slidesToShow: 1
                }
            },
            {
                breakpoint: 639,
                settings: {
                    slidesToShow: 4
                }
            },
            {
                breakpoint: 566,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 467,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 373,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });

    //---------------------------------------
    // open modal image on single product image click
    //---------------------------------------
    /*  $('.single-product-slider__slide').on('click', function(e){
        e.preventDefault();
        var large_image = $(this).find('img').data('large_image');
        var image_html = "<img src='" + large_image + "' alt='' />";
        var modal_window = $( '#modal' );
        modal_window.html(image_html);
        try {
        modal_window.foundation('_destroy');
        } catch(err){
          console.log( 's' );
        }
        var elem = new Foundation.Reveal(modal_window);
        modal_window.foundation('open');
      })*/

    //---------------------------------------
    // pause all videos
    //---------------------------------------
    function pauseAllVideos() {
        $('.product-video-iframe').each(function () {
            if (typeof $(this)[0].contentWindow.postMessage !== 'undefined') {
                $(this)[0].contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*');
                if ($(this).attr('src').indexOf("vimeo") >= 0) {
                    player = $f($(this)[0]);
                    player.api('unload');
                }
            }
        });
    }

    //---------------------------------------
    // play large video
    //---------------------------------------
    $('.product-videos__video-container').on('click', function (e) {
        var iframe_url = $(this).data('iframe');
        e.preventDefault();
        pauseAllVideos();
        $(this).html('<div class="responsive-embed widescreen"><iframe class="product-video-iframe" allowscriptaccess="always" src="' + iframe_url + '" width="560" height="315" frameborder="0" allowfullscreen="true" allowscriptaccess="always"></div>').css('background', 'none').addClass('product-videos__video-container--noaftereffects');
    })

    //---------------------------------------
    // similar product view all
    //---------------------------------------
    $('#similar-products .show-all').on('click', function (e) {
        e.preventDefault();

        $('#similar-products .show-all').toggleClass('close angle-right');
        if ($('#similar-products .show-all').hasClass('close')) {
            closetxt = $(this).data('closetxt');
            $('#similar-products .show-all').html(closetxt)
            $('.similar-products__body').hide();
            $('.similar-products__body--hidden').show();
        } else if ($('#similar-products .show-all').hasClass('angle-right')) {
            opentxt = $(this).data('opentxt');
            $('#similar-products .show-all').html(opentxt)
            $('.similar-products__body').show();
            $('.similar-products__body--hidden').hide();
        }
    });

    //---------------------------------------
    // videos view all
    //---------------------------------------
    $('#videos .show-all').on('click', function (e) {
        e.preventDefault();


        $('#videos .show-all').toggleClass('close angle-right');

        if ($('#videos .show-all').hasClass('close')) {
            closetxt = $(this).data('closetxt');
            $('#videos .show-all').html(closetxt)
            $('.product-videos__body').hide();
            $('.product-videos__body--hidden').show();
        } else if ($('#videos .show-all').hasClass('angle-right')) {
            opentxt = $(this).data('opentxt');
            $('#videos .show-all').html(opentxt)
            $('.product-videos__body').show();
            $('.product-videos__body--hidden').hide();
        }
        pauseAllVideos();

    });

    //---------------------------------------
    // related product view all
    //---------------------------------------
    $('#related-products .show-all').on('click', function (e) {
        e.preventDefault();

        $('#related-products .show-all').toggleClass('close angle-right');
        if ($('#related-products .show-all').hasClass('close')) {
            closetxt = $(this).data('closetxt');
            $('#related-products .show-all').html(closetxt)
            $('.related-products__body').hide();
            $('.related-products__body--hidden').show();
        } else if ($('#related-products .show-all').hasClass('angle-right')) {
            opentxt = $(this).data('opentxt');
            $('#related-products .show-all').html(opentxt)
            $('.related-products__body').show();
            $('.related-products__body--hidden').hide();
        }
    });

    //---------------------------------------
    // single product - related products slider
    //---------------------------------------
    $('.js-related-products-slider').slick({
        arrows: false,
        dots: true,
    });


});
